
export default {
  name: 'AppMarkdown',
  props: {
    text: {
      type: String,
      required: true
    },
    markdownOption: {
      type: Object,
      default: null
    }
  }
};
